var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("custom-filters", {
        staticClass: "d-flex justify-space-around",
        staticStyle: { height: "96px", "overflow-y": "auto" },
        attrs: { namespace: "sensors", "i18n-path": "sensors" }
      }),
      _vm._v(" "),
      _vm.frontSort
        ? _c(
            "v-data-table",
            _vm._b(
              {
                staticClass: "elevation-1 secondarybackground striped-table",
                attrs: {
                  dense: "",
                  "multi-sort": "",
                  "hide-default-footer": "",
                  "fixed-header": "",
                  "items-per-page": _vm.data.length,
                  "calculate-widths": "",
                  headers: _vm.headers,
                  items: _vm.data,
                  loading: _vm.loading,
                  height: _vm.height - 96 + "px"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.valid_nomenclature",
                      fn: function({ item }) {
                        return [
                          _c("display-icon-badge-tooltip", {
                            attrs: {
                              icon: "fiber_manual_record",
                              "icon-color":
                                item.valid_nomenclature === 1
                                  ? "success"
                                  : "grey"
                            }
                          })
                        ]
                      }
                    },
                    {
                      key: "item.temperature_meter",
                      fn: function({ item }) {
                        return [
                          item.temperature_meter === 1
                            ? _c("div", [_vm._v("Oui")])
                            : item.temperature_meter === 0
                            ? _c("div", [_vm._v("Non")])
                            : _c("div", [_vm._v("Non précisé")])
                        ]
                      }
                    },
                    {
                      key: "top",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-space-between" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "primary--text font-weight-bold ml-10 my-1"
                                },
                                [_vm._v("\n          Liste Sondes\n        ")]
                              ),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                staticClass: "my-1 mr-10",
                                attrs: { dense: "", label: "Tri sur la page" },
                                model: {
                                  value: _vm.frontSort,
                                  callback: function($$v) {
                                    _vm.frontSort = $$v
                                  },
                                  expression: "frontSort"
                                }
                              }),
                              _vm._v(" "),
                              _c("custom-page-selector", {
                                staticClass: "pa-2",
                                attrs: { namespace: "sensors" }
                              })
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2951023838
                )
              },
              "v-data-table",
              _vm.$attrs,
              false
            )
          )
        : _c(
            "v-data-table",
            _vm._b(
              {
                staticClass: "elevation-1 secondarybackground striped-table",
                attrs: {
                  dense: "",
                  "hide-default-footer": "",
                  "fixed-header": "",
                  "calculate-widths": "",
                  headers: _vm.headers,
                  "server-items-length": _vm.data.length,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDESC,
                  items: _vm.data,
                  loading: _vm.loading,
                  height: _vm.height - 96 + "px"
                },
                on: {
                  "update:sortBy": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function($event) {
                    _vm.sortDESC = $event
                  },
                  "update:sort-desc": function($event) {
                    _vm.sortDESC = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.valid_nomenclature",
                    fn: function({ item }) {
                      return [
                        _c("display-icon-badge-tooltip", {
                          attrs: {
                            icon: "fiber_manual_record",
                            "icon-color":
                              item.valid_nomenclature === 1 ? "success" : "grey"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "item.temperature_meter",
                    fn: function({ item }) {
                      return [
                        item.temperature_meter === 1
                          ? _c("div", [_vm._v("Oui")])
                          : item.temperature_meter === 0
                          ? _c("div", [_vm._v("Non")])
                          : _c("div", [_vm._v("Non précisé")])
                      ]
                    }
                  },
                  {
                    key: "top",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-space-between" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "primary--text font-weight-bold ml-10 my-1"
                              },
                              [_vm._v("\n          Liste Sondes\n        ")]
                            ),
                            _vm._v(" "),
                            _c("v-checkbox", {
                              staticClass: "my-1 mr-10",
                              attrs: { dense: "", label: "Tri sur la page" },
                              model: {
                                value: _vm.frontSort,
                                callback: function($$v) {
                                  _vm.frontSort = $$v
                                },
                                expression: "frontSort"
                              }
                            }),
                            _vm._v(" "),
                            _c("custom-page-selector", {
                              staticClass: "pa-2",
                              attrs: { namespace: "sensors" }
                            })
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              "v-data-table",
              _vm.$attrs,
              false
            )
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }